/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const callbackConfigUrlMax = 2048;

export const CallbackConfig = zod.object({
	method: zod.enum(['async_upload', 'url_upload', 'direct_upload']),
	url: zod
		.string()
		.max(callbackConfigUrlMax)
		.describe('URL to receive callback with moderated content')
});

export type CallbackConfig = zod.input<typeof CallbackConfig>;
export type CallbackConfigOutput = zod.output<typeof CallbackConfig>;
